/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import BaseIdObject from "@shared/BaseIdObject";


export default class TimeIntervalSimple extends BaseIdObject{


	startTime: number = 0
	endTime: number = 0
	note: string = null

	constructor(startTime: number, endTime: number, note: string) {
		super();
		this.startTime = startTime || null;
		this.endTime = endTime || null;
		this.note = note || null;
	}

	toString(){
		return "{start = " + new Date(this.startTime) + "(" + this.startTime + ")" + ", end = " + new Date(this.endTime) + "(" + this.endTime + ")}"
	}


}
